module.exports = __webpack_public_path__ + "img/fa-8@3x.cd72946f.png";